import { Stack } from '@ui-components/neo.tax';
import React from 'react';

import { YesNo } from './forms.enums';
import { StyledButtonGroup } from './forms.styled';
import { YesNoFormType } from './forms.types';

export const YesNoForm = ({ form }: { form: YesNoFormType }): React.ReactElement => (
  <Stack>
    <StyledButtonGroup<YesNo>
      value={form.value}
      disabled={form.disabled}
      id={form.id}
      options={form.options}
      onClick={form.onChange.bind(form)}
      optionsGrow
    />
  </Stack>
);
